"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DrawerHeaderTitle: function() {
        return _index.DrawerHeaderTitle;
    },
    drawerHeaderTitleClassNames: function() {
        return _index.drawerHeaderTitleClassNames;
    },
    renderDrawerHeaderTitle_unstable: function() {
        return _index.renderDrawerHeaderTitle_unstable;
    },
    useDrawerHeaderTitleStyles_unstable: function() {
        return _index.useDrawerHeaderTitleStyles_unstable;
    },
    useDrawerHeaderTitle_unstable: function() {
        return _index.useDrawerHeaderTitle_unstable;
    }
});
const _index = require("./components/DrawerHeaderTitle/index");
